import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Dialog,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { API_URL } from "../consts";
import { RisorseInfoCorrenti } from "../prismaTypes";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useState } from "react";
import { RisorsaInfo } from "./RisorsaInfo";
import { format, parseISO } from "date-fns";
import EditIcon from "@mui/icons-material/Edit";

export function TabellaDettagli(props: { risorsaId: number }) {
  const { risorsaId } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [open2, setOpen2] = useState(false);
  const handleClickOpen2 = () => {
    setOpen2(true);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };

  const [id, setId] = useState(0);

  const { isLoading, data } = useQuery<unknown, AxiosError, { risorseInfo: RisorseInfoCorrenti[] }>(
    ["risorse-info/getRisorseInfo", risorsaId],
    () => axios.get(API_URL + "risorse-info/getRisorseInfo/" + risorsaId).then((res) => res.data)
  );

  const edit = (id: number) => () => {
    setId(id);
    handleClickOpen2();
  };

  if (isLoading) return <></>;

  return (
    <>
      <Button
        variant="text"
        color="secondary"
        onClick={handleClickOpen}
        startIcon={<AddCircleOutlineIcon />}
      >
        Aggiungi dettaglio
      </Button>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Attivazione</TableCell>
              <TableCell align="right">Inizio Validità</TableCell>
              <TableCell align="right">Fine Validità</TableCell>
              <TableCell align="right">Durata slot</TableCell>
              <TableCell align="right">Num. Minimo Slot</TableCell>
              <TableCell align="right">Num. Massimo Slot</TableCell>
              <TableCell align="right">Max Slot per Giorno</TableCell>
              <TableCell align="right">Inizio disponibilità (ora)</TableCell>
              <TableCell align="right">Fine disponibilità (ora)</TableCell>
              <TableCell align="right">Annullabilità (minuti)</TableCell>
              <TableCell align="right">Pagamento a prenotazione</TableCell>
              <TableCell align="right">Pagamento a scadenza</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.risorseInfo.map((row) => (
              <TableRow key={row.id}>
                <TableCell>
                  <IconButton aria-label="edit" sx={{ p: 0 }} onClick={edit(row.id)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
                <TableCell>{row.attivo ? "Si" : "No"}</TableCell>
                <TableCell>
                  {format(
                    new Date(row.inizioValidita === null ? "" : row.inizioValidita),
                    "dd/MM/yyyy"
                  )}
                </TableCell>
                <TableCell>
                  {format(
                    new Date(row.fineValidita === null ? "" : row.fineValidita),
                    "dd/MM/yyyy"
                  )}
                </TableCell>
                <TableCell align="right">{row.durataSlot}</TableCell>
                <TableCell align="right">{row.numeroMinimoSlotPrenotabili}</TableCell>
                <TableCell align="right">{row.numeroMassimoSlotPrenotabili}</TableCell>
                <TableCell align="right">{row.massimoSlotPrenotabiliPerGiorno}</TableCell>
                <TableCell align="right">
                  {row.oraInizioDisponibilita === null
                    ? ""
                    : format(parseISO(row.oraInizioDisponibilita.slice(0, -1)), "HH:mm")}
                </TableCell>
                <TableCell align="right">
                  {row.oraFineDisponibilita === null
                    ? ""
                    : format(parseISO(row.oraFineDisponibilita.slice(0, -1)), "HH:mm")}
                </TableCell>
                <TableCell align="right">{row.prenotazioneAnnullabileEntroMinuti}</TableCell>
                <TableCell align="right">{row.pagamentoAnticipato ? "Si" : "No"}</TableCell>
                <TableCell align="right">{row.pagamentoPosticipato ? "Si" : "No"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={open} onClose={handleClose} fullScreen={fullScreen} fullWidth={true}>
        <RisorsaInfo risorseId={risorsaId} handleClose={handleClose} />
      </Dialog>
      <Dialog open={open2} onClose={handleClose2} fullScreen={fullScreen} fullWidth={true}>
        <RisorsaInfo id={id} handleClose={handleClose2} />
      </Dialog>
    </>
  );
}
